import { RESULTS_PATHNAME } from '../constants';
export const isOnResultsPage = pathname => {
  return pathname === RESULTS_PATHNAME;
};